import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import useQuotations from '../hooks/useQuotations';
import QuotationsList from './QuotationsList';
import QuotationDisplay from './QuotationDisplay';
import './QuotationsManagement.css';

const QuotationsManagement = () => {
  const { token } = useAuth();
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [showQuotationModal, setShowQuotationModal] = useState(false);

  const {
    quotations,
    loading,
    error,
    searchTerm,
    setSearchTerm,
    filters,
    updateFilters,
    clearFilters,
    handleSort,
    getSortIndicator,
    fetchQuotations,
    fetchQuotationById,
    formatDate,
    formatCurrency,
    getQuotationStatusColor,
    calculateQuotationTotal
  } = useQuotations(token);

  // Handle viewing a quotation
  const handleViewQuotation = async (quotation) => {
    try {
      // Fetch the full quotation details by ID
      const fullQuotation = await fetchQuotationById(quotation.quotationId);
      if (fullQuotation) {
        setSelectedQuotation(fullQuotation);
        setShowQuotationModal(true);
      }
    } catch (error) {
      console.error('Error loading quotation details:', error);
    }
  };

  // Handle closing the quotation modal
  const handleCloseQuotation = () => {
    setShowQuotationModal(false);
    setSelectedQuotation(null);
  };

  // Handle refresh
  const handleRefresh = () => {
    fetchQuotations();
  };

  return (
    <div className="quotations-management">
      <div className="quotations-header">
        <div className="header-content">
          <h1>Gerenciamento de Cotações</h1>
          <p>Visualize e gerencie todas as cotações do sistema</p>
        </div>
        <div className="header-actions">
          <button 
            onClick={handleRefresh}
            className="refresh-btn"
            disabled={loading}
            title="Atualizar cotações"
          >
            🔄 {loading ? 'Carregando...' : 'Atualizar'}
          </button>
        </div>
      </div>

      <div className="quotations-content">
        <QuotationsList
          quotations={quotations}
          loading={loading}
          error={error}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filters={filters}
          updateFilters={updateFilters}
          clearFilters={clearFilters}
          handleSort={handleSort}
          getSortIndicator={getSortIndicator}
          formatDate={formatDate}
          formatCurrency={formatCurrency}
          getQuotationStatusColor={getQuotationStatusColor}
          calculateQuotationTotal={calculateQuotationTotal}
          onViewQuotation={handleViewQuotation}
        />
      </div>

      {/* Quotation Display Modal */}
      {showQuotationModal && (
        <QuotationDisplay
          quotation={selectedQuotation}
          formatDate={formatDate}
          formatCurrency={formatCurrency}
          getQuotationStatusColor={getQuotationStatusColor}
          calculateQuotationTotal={calculateQuotationTotal}
          onClose={handleCloseQuotation}
        />
      )}
    </div>
  );
};

export default QuotationsManagement;
